import { useDynamicEntity } from './useDynamicEntity';
import { useAuth } from './index';

const useContractSubjects = () => {
  const { user } = useAuth();
  const dynamicHook = useDynamicEntity({
    entityType: 'contractSubjects',
    gqlEntityKey: 'contract_subjects',
    queryName: 'GET_CONTRACT_SUBJECTS_QUERY',
    createMutation: 'CREATE_CONTRACT_SUBJECT_MUTATION',
    updateMutation: 'UPDATE_CONTRACT_SUBJECT_MUTATION',
    deleteMutation: 'DELETE_CONTRACT_SUBJECT_MUTATION',
    updateVariableName: 'set',
    transformData: (contractSubject) => ({
      ...contractSubject,
      company_name: contractSubject.company?.name || `Company ${contractSubject.company_id}`,
      name: contractSubject.name,
      description: contractSubject.description,
      isProjectBased: contractSubject.is_project_based,
      status: contractSubject.status ? 'active' : 'inactive',
      companyId: contractSubject.company_id,
    }),
    transformFormData: (formData) => ({
      name: formData.name,
      description: formData.description || null,
      is_project_based: formData.isProjectBased === false ? false : (formData.isProjectBased || false),
      status: formData.status === 'active',
      company_id: formData.companyId,
    }),
    customWhereCondition: user?.role === 'ROOT' ? {} : { company_id: { _eq: user?.companyId } },
  });
  return {
    ...dynamicHook,
    isRootUser: user?.role === 'ROOT',
  };
};

export { useContractSubjects }; 